import { Component } from '@angular/core';
import { ORCIDWorkEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Works') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-orcidwork-form',
    templateUrl: './orcidwork.form.component.html'
})
export class ORCIDWorkFormComponent extends BaseFormComponent {
    public record!: ORCIDWorkEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'workExternalIDs', sectionName: 'Work External IDs', isExpanded: false }
        ]);
    }
}

